import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavController, ToastController, LoadingController,Nav, Events } from 'ionic-angular';
import {  ListMasterPageAproval } from "@pages/aproval_erp";

import { UserApproval, GlobalVarApproval } from '@providers/index';
import { MainPage } from '../';
import { UserMyRadiant } from "@providers/index";
import { TabsPage } from '@pages/dashboard';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html'
})
export class LoginPage {
  // The account fields for the login form.
  // If you're using the username field with or without email, make
  // sure to add it to the type
  account: any = {
    employee_id : this.userMyRadiant.data.Employee_ID,
    employee_nik : this.userMyRadiant.data.NIK,
    UserName : this.userMyRadiant.data.email,
    Pass : '',
    From : 'mobile'
  };

  // Our translated text strings
  loginErrorString: string;

  selectedAnimation: any = "other";
  animations: any;
  interactive = true;
  anim: any;
  animationSpeed: number = 1;

  interactiveAnimationOption = {
    loop: true,
    prerender: false,
    autoplay: false,
    autoloadSegments: false,
    path: 'assets/animations/other/jake.json'
  }

  otherAnimations = [
    {
      path: 'assets/animations/other/verification.json'
    },
  ];
  closeAnimations = [
    {
      path : 'assets/animations/lottie/close.json'
    }
  ];

  constructor(
    public navCtrl: NavController,
    public user: UserApproval,
    public globalvar: GlobalVarApproval,
    public toastCtrl: ToastController,
    public events : Events,
    // public translateService: TranslateService,
    public loadingCtrl: LoadingController,
    public nav : Nav,
    public userMyRadiant : UserMyRadiant,
  ) {
    this.changeAnimations();
    this.doLogin();
  }

  // Attempt to login in through our User service
  doLogin() {
    
    this.user.login(this.account).subscribe((resp:any) => {
      let obj = resp;
      if(obj.success){
        localStorage.setItem('app_user',JSON.stringify(resp));
        localStorage.setItem('app_login','true');

        this.globalvar.app_login = true;
        this.globalvar.app_user.user_attribute = resp.user_attribute;
        this.globalvar.app_user.usergroup = resp.usergroup;

        this.nav.setRoot(ListMasterPageAproval);
      }else{
        setTimeout(() => {
          this.selectedAnimation = "close";
          this.changeAnimations();
          setTimeout(() => {
            this.nav.setRoot(TabsPage,{tabIndex:1});
            this.events.publish('modul:myradiant');
          }, 500);
        }, 2000);
      }
    }, (err) => {
      let toast = this.toastCtrl.create({
        message: this.loginErrorString,
        duration: 3000,
        position: 'top'
      });
      toast.present();
    });
  }
  handleAnimation(anim) {
    this.anim = anim;
  }

  stop() {
      this.anim.stop();
  }

  
  setSpeed() {
      this.anim.setSpeed(this.animationSpeed);
  }

  animate() {
    this.anim.playSegments([[27, 142], [14, 26]], true);
  }

  changeAnimations() {
    this.interactive = false;
    switch (this.selectedAnimation) {
      case "other":
        this.animations = this.otherAnimations;
        break;
      case "close":
        this.animations = this.closeAnimations;
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/aproval_erp/login/login.ts